import { render, staticRenderFns } from "./three-canvas.vue?vue&type=template&id=2bc4d24b&scoped=true&"
import script from "./three-canvas.vue?vue&type=script&lang=js&"
export * from "./three-canvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4d24b",
  null
  
)

export default component.exports